export function resolveCmsDevProxyUrl(url: string | undefined | null): string | undefined | null {
  if (!url) return url;
  if (url.startsWith('data:') || url.startsWith('blob:')) return url;
  const useProxy =
    import.meta.env.DEV && import.meta.env.VITE_CMS_USE_PROXY !== 'false';
  if (!useProxy) return url;

  if (url.startsWith('/__cms')) {
    return url;
  }

  if (url.startsWith('/api/')) {
    return `/__cms${url}`;
  }

  if (url.startsWith('/uploads/')) {
    return `/__cms/api${url}`;
  }

  try {
    const parsed = new URL(url);
    const loopback =
      parsed.hostname === '127.0.0.1' || parsed.hostname === 'localhost';
    const matchesConfiguredCms = matchesViteCmsOrigin(parsed);
    if (loopback || matchesConfiguredCms) {
      const pathname = parsed.pathname.startsWith('/uploads/')
        ? `/api${parsed.pathname}`
        : parsed.pathname;
      return `/__cms${pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    return url;
  }
  return url;
}

function matchesViteCmsOrigin(parsed: URL) {
  const raw = import.meta.env.VITE_CMS_ORIGIN;
  if (!raw) return false;
  try {
    const cms = new URL(raw);
    return parsed.protocol === cms.protocol && parsed.host === cms.host;
  } catch {
    return false;
  }
}
